import { ConfigType } from "../utils/requestAPI";

export type paginationType = {
  limit?: number;
  total?: number;
  totalPages?: number;
  currentPage?: number;
  page?: number;
  search?: string;
  type?: string;
  bedrooms: number;
  bathrooms: number;
};

const bookings = {
  getProperties: (params?: paginationType): ConfigType => {
    return {
      method: "get",
      url: "admins/bookings",
      params,
    };
  },
  getSingleProperty: (id: string): ConfigType => {
    return {
      method: "get",
      url: `bookings/${id}`,
    };
  },

  deleteBooking: (id: string): ConfigType => {
    return {
      method: "delete",
      url: `booking/${id}`,
    };
  },
};

export default bookings;
